<nb-card class="chart-container" *ngIf="results?.length > 0; else noData">
    <nb-card-header>
      <div class="header-title">{{ title }}</div>
    </nb-card-header>
    <nb-card-body>
      <ngx-charts-advanced-pie-chart
        [name]="name"
        [title]="title"
        [results]="results"
        [customColors]="customColors"
        [gradient]="gradient"
        [activeEntries]="activeEntries"
        [label]="label"
        [tooltipDisabled]="tooltipDisabled"
        [tooltipTemplate]="tooltipTemplate"
        [nameFormatting]="nameFormatting"
        [valueFormatting]="valueFormatting"
        [percentageFormatting]="percentageFormatting"
        [animations]="animations"
        [scheme]="scheme"
        [view]="view"
      ></ngx-charts-advanced-pie-chart>
    </nb-card-body>
</nb-card>
<ng-template #noData>
    <div class="no-data" *ngIf="results">No data available</div>
</ng-template>
